export const NEW_PROFILE_GET_HEALTH_DATA_BEGIN = 'NEW_PROFILE_GET_HEALTH_DATA_BEGIN';
export const NEW_PROFILE_GET_HEALTH_DATA_SUCCESS = 'NEW_PROFILE_GET_HEALTH_DATA_SUCCESS';
export const NEW_PROFILE_GET_HEALTH_DATA_FAILURE = 'NEW_PROFILE_GET_HEALTH_DATA_FAILURE';
export const NEW_PROFILE_GET_HEALTH_DATA_DISMISS_ERROR =
  'NEW_PROFILE_GET_HEALTH_DATA_DISMISS_ERROR';
export const NEW_PROFILE_GET_HEALTH_DATA_HISTORY_BEGIN =
  'NEW_PROFILE_GET_HEALTH_DATA_HISTORY_BEGIN';
export const NEW_PROFILE_GET_HEALTH_DATA_HISTORY_SUCCESS =
  'NEW_PROFILE_GET_HEALTH_DATA_HISTORY_SUCCESS';
export const NEW_PROFILE_GET_HEALTH_DATA_HISTORY_FAILURE =
  'NEW_PROFILE_GET_HEALTH_DATA_HISTORY_FAILURE';
export const NEW_PROFILE_GET_HEALTH_DATA_HISTORY_DISMISS_ERROR =
  'NEW_PROFILE_GET_HEALTH_DATA_HISTORY_DISMISS_ERROR';
export const NEW_PROFILE_GET_FIRST_STEPS_BEGIN = 'NEW_PROFILE_GET_FIRST_STEPS_BEGIN';
export const NEW_PROFILE_GET_FIRST_STEPS_SUCCESS = 'NEW_PROFILE_GET_FIRST_STEPS_SUCCESS';
export const NEW_PROFILE_GET_FIRST_STEPS_FAILURE = 'NEW_PROFILE_GET_FIRST_STEPS_FAILURE';



// WEBPACK FOOTER //
// ./src/features/new-profile/redux/constants.js